import {z} from 'zod';

export const variableAlarmTypeEligibilitySchema = z.object({
    runningToilet: z.boolean(),
    indoorClimateHumidityHigh: z.boolean(),
    indoorClimateHumidityLow: z.boolean(),
    indoorClimateHumidityLeakage: z.boolean(),
    indoorClimateTemperatureHigh: z.boolean(),
    indoorClimateTemperatureLow: z.boolean(),
    indoorClimateCo2High: z.boolean(),
    customizedAlarm: z.boolean(),
});

export type VariableAlarmTypeEligibility = z.infer<typeof variableAlarmTypeEligibilitySchema>;

type Texts = {
    header: string;
    description: string;
};
export type VariableAlarmSettings = {
    allocationUnit: string | null;
    unit: number | null;
    deviationType: string | null;
    deviationValue: number | null;
    minimumDeviationPeriod: number | null;
};
export type VariableAlarmTemplate = {
    type: string;
    translation: Texts;
    variableAlarmEligibility: boolean;
};
